// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-search-box {
  font-family: var(--wm-font-family-content, inherit);
  cursor: pointer;
  margin: 10px;
}
wm-search-box wm-img {
  height: 30px;
}
wm-search-box ion-card {
  overflow: hidden;
  width: 90%;
  max-height: 250px;
  border-radius: 15px;
  padding: 10px;
  margin: auto;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
}
wm-search-box ion-card wm-img {
  display: block;
  background-color: var(--wm-color-skeleton);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
wm-search-box ion-card .wm-box-taxonomies {
  position: absolute;
  top: 10px;
  padding: 1%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
wm-search-box ion-card .wm-box-taxonomies .wm-box-taxonomy {
  left: 0px;
  top: 0px;
  border-radius: 25px;
  padding: 6px;
  background-color: white;
  border: 1px solid #888888;
  margin: 3px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
}
wm-search-box ion-card .wm-box-taxonomies .wm-box-taxonomy div[appBuildSvg] {
  display: flex;
}
wm-search-box ion-card .wm-box-taxonomies .wm-box-taxonomy div[appBuildSvg] svg {
  width: 22px;
  height: 22px;
}
wm-search-box ion-card .wm-box-taxonomies .wm-box-taxonomy div[appBuildSvg] svg circle {
  fill: transparent;
}
wm-search-box ion-card .wm-box-taxonomies .wm-box-taxonomy div[appBuildSvg] svg g {
  fill: var(--wm-color-darkgrey);
}
wm-search-box ion-card .wm-box-taxonomies .wm-box-taxonomy > * {
  flex: 0 1 auto;
  align-self: auto;
  font-family: var(--wm-font-family-content, inherit);
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
}
wm-search-box ion-card .wm-box-header-no-photo {
  height: fit-content;
}
wm-search-box ion-card .wm-box-header-no-photo .wm-box-taxonomies {
  position: relative;
  top: 0;
  padding: 1%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
wm-search-box ion-card ion-card-header {
  padding: 0 15px;
  text-align: left;
}
wm-search-box ion-card ion-card-header ion-card-subtitle {
  text-align: left;
  color: var(--wm-color-primary);
  text-transform: uppercase;
  margin: 0;
  padding: 15px 0 0;
  font-size: var(--wm-font-xsm);
  font-weight: var(--wm-font-weight-light);
}
wm-search-box ion-card ion-card-header ion-card-title {
  text-align: left;
  color: var(--wm-color-dark);
  margin: 10px;
  padding: 5px 0 0;
  font-size: var(--wm-font-sm);
  font-weight: var(--wm-font-weight-normal);
  font-family: var(--wm-font-family-content, inherit);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}
wm-search-box ion-card ion-card-header ion-card-title::first-letter {
  text-transform: uppercase;
}
wm-search-box ion-card ion-card-header .wm-card-big-subtitle-skeleton {
  margin: 15px 0 0;
  height: var(--wm-font-xsm);
  width: 50%;
}
wm-search-box ion-card ion-card-header .wm-card-big-title-skeleton {
  margin: 5px 0 0;
  height: var(--wm-font-md);
  width: 70%;
}
wm-search-box ion-card .wm-search-box-properties {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}
wm-search-box ion-card .wm-search-box-properties .wm-search-box-property {
  position: relative;
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  color: var(--wm-color-darkgrey);
  font-size: var(--wm-font-xsm);
}
wm-search-box ion-card .wm-search-box-properties .wm-search-box-property:not(:last-of-type) {
  padding-right: 22px;
}
wm-search-box ion-card .wm-search-box-properties .wm-search-box-property:not(:last-of-type)::after {
  content: "";
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--wm-color-skeleton);
}
wm-search-box ion-card .top-right-content {
  position: absolute;
  right: 10px;
  top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/search-box/search-box.component.scss","webpack://./src/app/shared/wm-core/projects/wm-core/src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACE,mDAAA;EACA,eAAA;EACA,YAAA;AAAF;AACE;EACE,YAAA;AACJ;AACE;EACE,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;ECbF,2CAAA;ADeF;AACI;EACE,cAAA;EACA,0CAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AACN;AACI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACN;AAAM;EACE,SAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AACR;AACQ;EACE,aAAA;AACV;AAAU;EACE,WAAA;EACA,YAAA;AAEZ;AADY;EACE,iBAAA;AAGd;AADY;EACE,8BAAA;AAGd;AACQ;EACE,cAAA;EACA,gBAAA;EACA,mDAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;AACV;AAGI;EACE,mBAAA;AADN;AAEM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAAR;AAII;EACE,eAAA;EACA,gBAAA;AAFN;AAGM;EACE,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,wCAAA;AADR;AAGM;EACE,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,yCAAA;EACA,mDAAA;EAIA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AAJR;AAJQ;EACE,yBAAA;AAMV;AAIM;EACE,gBAAA;EACA,0BAAA;EACA,UAAA;AAFR;AAIM;EACE,eAAA;EACA,yBAAA;EACA,UAAA;AAFR;AAKI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAHN;AAIM;EACE,kBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EAEA,+BAAA;EACA,6BAAA;AAHR;AAKQ;EACE,mBAAA;AAHV;AAKQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;AAHV;AAOI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AALN","sourcesContent":["@import '../../theme/mixins.scss';\nwm-search-box {\n  font-family: var(--wm-font-family-content, inherit);\n  cursor: pointer;\n  margin: 10px;\n  wm-img {\n    height: 30px;\n  }\n  ion-card {\n    overflow: hidden;\n    width: 90%;\n    max-height: 250px;\n    border-radius: 15px;\n    padding: 10px;\n    margin: auto;\n    @include box-shadow-light;\n\n    wm-img {\n      display: block;\n      background-color: var(--wm-color-skeleton);\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: cover;\n    }\n    .wm-box-taxonomies {\n      position: absolute;\n      top: 10px;\n      padding: 1%;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      .wm-box-taxonomy {\n        left: 0px;\n        top: 0px;\n        border-radius: 25px;\n        padding: 6px;\n        background-color: white;\n        border: 1px solid #888888;\n        margin: 3px;\n\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-content: stretch;\n        align-items: center;\n\n        div[appBuildSvg] {\n          display: flex;\n          svg {\n            width: 22px;\n            height: 22px;\n            circle {\n              fill: transparent;\n            }\n            g {\n              fill: var(--wm-color-darkgrey);\n            }\n          }\n        }\n        > * {\n          flex: 0 1 auto;\n          align-self: auto;\n          font-family: var(--wm-font-family-content, inherit);\n          display: inline-flex;\n          flex-direction: row;\n          flex-wrap: nowrap;\n          justify-content: flex-start;\n          align-content: center;\n          align-items: center;\n        }\n      }\n    }\n    .wm-box-header-no-photo {\n      height: fit-content;\n      .wm-box-taxonomies {\n        position: relative;\n        top: 0;\n        padding: 1%;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n      }\n    }\n\n    ion-card-header {\n      padding: 0 15px;\n      text-align: left;\n      ion-card-subtitle {\n        text-align: left;\n        color: var(--wm-color-primary);\n        text-transform: uppercase;\n        margin: 0;\n        padding: 15px 0 0;\n        font-size: var(--wm-font-xsm);\n        font-weight: var(--wm-font-weight-light);\n      }\n      ion-card-title {\n        text-align: left;\n        color: var(--wm-color-dark);\n        margin: 10px;\n        padding: 5px 0 0;\n        font-size: var(--wm-font-sm);\n        font-weight: var(--wm-font-weight-normal);\n        font-family: var(--wm-font-family-content, inherit);\n        &::first-letter {\n          text-transform: uppercase;\n        }\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        /* white-space: nowrap; */\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .wm-card-big-subtitle-skeleton {\n        margin: 15px 0 0;\n        height: var(--wm-font-xsm);\n        width: 50%;\n      }\n      .wm-card-big-title-skeleton {\n        margin: 5px 0 0;\n        height: var(--wm-font-md);\n        width: 70%;\n      }\n    }\n    .wm-search-box-properties {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: flex-start;\n      .wm-search-box-property {\n        position: relative;\n        order: 0;\n        flex: 0 1 auto;\n        align-self: center;\n\n        color: var(--wm-color-darkgrey);\n        font-size: var(--wm-font-xsm);\n\n        &:not(:last-of-type) {\n          padding-right: 22px;\n        }\n        &:not(:last-of-type)::after {\n          content: '';\n          position: absolute;\n          right: 8px;\n          top: 50%;\n          transform: translateY(-50%);\n          width: 6px;\n          height: 6px;\n          border-radius: 50%;\n          background-color: var(--wm-color-skeleton);\n        }\n      }\n    }\n    .top-right-content {\n      position: absolute;\n      right: 10px;\n      top: 10px;\n    }\n  }\n}\n","@mixin box-shadow-light {\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n@mixin box-shadow-dark {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
